$(document).ready(function () {
    /**
    * TCR Module implementation
    */
    if (tcr_enable == true) {
        var tcr = document.createElement('script');
        tcr.src = tcr_src + '/assets/js/site.js';
        document.body.appendChild(tcr);

        let results = {};
        let value, key;
        let objectStructure = null;
        let index = 0;
        function createObj(obj,boxes) {
            key = obj.closest('.box').find('h2').data('title');
            value = obj.closest('li').find('input').val();

            if (objectStructure == null) {
                results[key] = value;

            } else if (obj.closest('.box').hasClass('box--multiple-answer')) {
                if (typeof results[key] === 'object') {
                    results[key][index++] = value;

                } else {
                    results[key] = {};
                    results[key][index++] = value;
                }

            } else {
                results[key] = value;
            }

            objectStructure = results;
            // console.log(objectStructure);

            funnelEventEmitter('surveyResults', objectStructure);
        }
        
        $('label').on('click', function () {
            const boxes = $('.boxes');

            createObj($(this), boxes);
        })
    }

    function showCTA() {
        $('#nextStep').removeClass('hidden').addClass('show');
    }

    function hideCTA() {
        $('#nextStep').removeClass('show').addClass('hidden');
    }

    function pagination() {
        const boxes = $('.boxes');        

        hideCTA();

        $('label').on('click', function () {
            // const surveyForm = $('#surveyForm');
            // console.log($(this))

            if ($(this).parent().parent().attr('data-answer') == 'checkbox') {
                // console.log('checkbox')

                $(this).parent().toggleClass('checked');

                if ($(window).width() <= 1024 && boxes.hasClass('boxes--2Sections') && !boxes.hasClass('two')) {
                    $('#proceedStep').removeClass('hidden').addClass('show');
                }

            } else {
                // console.log('not checkbox')
                $('.answers li').removeClass('checked');
                $(this).addClass('checked');
            }

            // maybe we should... talk tomorrow 
            if (boxes.hasClass('one') && !$('.box.one').hasClass('box--multiple-answer')) {
                boxes.removeClass('one').addClass('two');
            } else if (boxes.hasClass('two') && !boxes.hasClass('boxes--2Sections') && $(this).parent().attr('data-answer') == 'radio'){
                boxes.removeClass('two').addClass('three');
            }
        });
        
        if (boxes.hasClass('boxes--2Sections')) {
            $('.box.two label').on('click', function () {
                showCTA();
                $('.boxes.two .box').addClass('clicked');
                $('.skip').addClass('clicked');
            });
        } else {
            $('.box.three label').on('click', function () {
                showCTA();
                $('.boxes.three .box').addClass('clicked');
                $('.skip').addClass('clicked');
            });
        }

        $('#proceedStep').on('click', function() {
            if (boxes.hasClass('two') && !boxes.hasClass('boxes--2Sections')) {
                boxes.removeClass('two').addClass('three');
            } else if (boxes.hasClass('one')) {
                boxes.removeClass('one').addClass('two');
            }
    
            $('#proceedStep').removeClass('show').addClass('hidden');
        });
    }
    
    pagination();
    
    if ($(window).width() > 1024) {
        showCTA();
    }
    
    $(window).resize(function () {
        if (this.resizeWindow) {
            clearTimeout(this.resizeWindow);
        }
    
        this.resizeWindow = setTimeout(function () {
            if ($(window).width() > 1024) {
                showCTA();
    
            } else if ($(window).width() <= 1024) {
                hideCTA();
            }
        }, 500);
    });

    //- Set current Year to footer Copyright
    if($('#year').length) {
        let thisDate = new Date();
        $('#year').html(thisDate.getFullYear());
    }

    /**
     * Check if we have answers to add to url as parameters and add them one by one right before the redirect to product page
     */
    $('#nextStep').on('click', function(e) {
        e.preventDefault();

        let url = $('#nextStep').attr('href');
        const checkedAswers = $('.answers__item input:checked');

        $(checkedAswers).each(function(item){
            const addParams = $(checkedAswers[item]).data('answer-param');
            const thisParamName = $(checkedAswers[item]).attr('name').toLocaleLowerCase();
            const thisParamValue = $(checkedAswers[item]).attr('id').toLocaleLowerCase();
            // console.log(shouldBeAddedToParams && url.length && url.includes('?'))
            if (addParams && url.length && url.includes('?')) {
                url = url+`&${thisParamName}=${thisParamValue}`
              } else if (addParams && url.length && !url.includes('?')) {
                url = url+`?${thisParamName}=${thisParamValue}`
              }
            }
        );

        document.location = url;
    });
});